import React from "react"
import { SPECIALIST } from "../../../constants"
import { GeneralOptions, SpecialistOptions } from "./options"

const PostIntentOptions = props => {
  return props.response !== SPECIALIST ? (
    <GeneralOptions {...props} />
  ) : (
    <SpecialistOptions {...props} />
  )
}

export default PostIntentOptions



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/PostIntentOptions.js